export default "__VITE_ASSET__CqB1CeGs__"